// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"gX-z","sponsoredTooltipWrapper":"hX-z","sponsoredTooltip":"iX-z","newCard":"jX-z"};